"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var EventBus = /** @class */ (function () {
    function EventBus() {
        this.bus = new vue_1.default();
        vue_1.default.prototype.$bus = this.bus;
    }
    EventBus.prototype.$emit = function (event, params) {
        this.bus.$emit(event, params);
    };
    EventBus.prototype.$on = function (event, listener) {
        this.bus.$on(event, listener);
    };
    EventBus.prototype.$off = function (event, listener) {
        this.bus.$off(event, listener);
    };
    return EventBus;
}());
exports.default = EventBus;
